const getPlugin = () => {
  if (typeof window !== 'undefined' && window.Capacitor) {
    return window.Capacitor.Plugins.StarXpandPlugin;
  }
  return null;
};

const StarXpandPlugin = {
  searchPrinters: () => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.searchPrinters();
  },
  connectPrinter: (options) => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.connectPrinter(options);
  },
  disconnectPrinter: () => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.disconnectPrinter();
  },
  print: (options) => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.print(options);
  },
  printRawData: (options) => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.printRawData(options);
  },
  getStatus: () => {
    const plugin = getPlugin();
    if (!plugin) return Promise.reject(new Error('StarXpandPlugin not available'));
    return plugin.getStatus();
  },
};

module.exports = StarXpandPlugin;
module.exports.default = StarXpandPlugin;
